import axios from 'axios';
import { t } from 'i18next';
import notify from 'src/configs/notify';

export const apiGetStatsOverview = async () => {
  try {
    const response = await axios.get('/api/v1/statistics/overview');
    return response.data;
  } catch (e) {
    notify({
      message: t(e.response?.data?.error ?? e.message),
      type: 'error',
    });
    return null;
  }
};

export const apiGetTopSales = async () => {
  try {
    const response = await axios.get('/api/v1/statistics/top-sales');
    return response.data;
  } catch (e) {
    notify({
      message: t(e.response?.data?.error ?? e.message),
      type: 'error',
    });
    return [];
  }
};

export const apiGetBalanceHistory = async () => {
  try {
    const response = await axios.get('/api/v1/statistics/balance-history');
    return response.data;
  } catch (e) {
    notify({
      message: t(e.response?.data?.error ?? e.message),
      type: 'error',
    });
    return [];
  }
};
